<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase">Consultas Agendadas</span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        *ngIf="!isDoctor"
        class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
        aria-label=".form-select-lg"
        [formControl]="doctorControl"
      >
        <option value="">Todos os Atendentes</option>
        <option *ngFor="let doctor of doctors" [value]="doctor.id">{{ doctor.name }}</option>
      </select>

      <select
        class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
        aria-label=".form-select-lg"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
      </select>

      <div>
        <input [formControl]="acaoInput" type="text" class="form-input w-56" placeholder="Pesquise por Colaborador" />
      </div>
      <div class="flex justify-between">
        <button title="Filtrar Atestados" (click)="filtrar()" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          title="Limpar Filtro"
          (click)="limparFiltros()"
          title="Limpar Filtros"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="consultas.length > 0" class="flex flex-col">
    <div class="overflow-x-hidden">
      <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
        <div class="overflow-hidden">
          <table class="min-w-full">
            <thead class="border-b border-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Colaborador
                </th>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Data
                </th>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Horário
                </th>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Modalidade
                </th>
                <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                  Status
                </th>
              </tr>
            </thead>

            <tbody *ngIf="consultas.length > 0">
              <tr class="bg-white hover:bg-iceberg" *ngFor="let consulta of consultas">
                <td class="px-6 py-4 pl-0 text-left font-medium text-md text-chathams-blue">
                  {{ consulta.employee?.name }}
                </td>
                <td class="px-6 py-4 pl-0 text-left font-medium text-md text-chathams-blue">
                  {{ consulta.appointmentDate | date: 'dd/MM/yyyy' }}
                </td>
                <td class="px-6 py-4 pl-0 text-left font-medium text-md text-chathams-blue">
                  {{ consulta.appointmentDate | date: 'HH:mm' }}
                </td>
                <td class="px-6 py-4 pl-0 text-left font-medium text-md text-chathams-blue">
                  {{ consulta.modality | modalidadeConsulta }}
                </td>
                <td class="text-left font-medium text-md text-chathams-blue">
                  <app-consulta-status [status]="consulta.status"></app-consulta-status>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <hr />
    <div class="flex justify-end my-5">
      <app-paginacao
        [numeroDeItens]="dadosPaginacao.itensTotal"
        [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
        [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
        [totalPage]="dadosPaginacao.totalPaginas"
        (mudouPagina)="mudouPagina($event)"
        (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      ></app-paginacao>
    </div>
    <hr />
  </div>
  <app-no-results-found [condition]="consultas.length === 0"></app-no-results-found>
</form>
